import { useTemplate } from "@hooks/useTemplate";
import {
  type ComponentProps,
  type NormalisedProductVariant,
} from "@ts/components";
import React, { type Dispatch, type FC, type SetStateAction } from "react";

export type FindInStorePopupInputProps = ComponentProps & {
  setActive: Dispatch<SetStateAction<boolean>>;
  selectedVariant: NormalisedProductVariant;
  countryCode?: string;
};

export type FindInStorePopupOutputProps = FindInStorePopupInputProps & {
  stockLevelsLabel?: string;
  lowStockThreshold: number;
  countryCode?: string;
};

export const withFindInStorePopup =
  (Component: FC<FindInStorePopupOutputProps>) =>
  ({
    name = "FindInStorePopup",
    setActive,
    className,
    selectedVariant,
    countryCode,
  }: FindInStorePopupInputProps) => {
    const { product } = useTemplate();
    const { additionalFindInStoreStockLevels: stockLevelsLabel } =
      product || {};
    const lowStockThreshold = Number(product?.settingLowStockThreshold);

    Component.displayName = name;

    return (
      <Component
        setActive={setActive}
        className={className}
        stockLevelsLabel={stockLevelsLabel}
        selectedVariant={selectedVariant}
        lowStockThreshold={lowStockThreshold}
        countryCode={countryCode}
      />
    );
  };
